module.exports = __webpack_public_path__ + "static/img/maskCount_white.c2a6425d.png";